// src/pages/Concursos.jsx
import React from "react";
import { Link } from "react-router-dom";
import { Seo } from "../components/Seo";
import { BreadcrumbLd } from "../components/BreadcrumbLd";
import { usePrecios } from "../hooks/usePrecios";

const euros = (n) =>
  new Intl.NumberFormat("es-ES", {
    style: "currency",
    currency: "EUR",
    maximumFractionDigits: 0,
  }).format(n);

export default function Concursos() {
  const { precios, error: preciosError } = usePrecios();
  const preparacionCompeticion = precios?.Concursos?.preparacionCompeticion;

  return (
    <div className="container" style={{ paddingTop: 10, paddingBottom: 60 }}>
      <Seo
        title="Concursos | Preparación de competición y galopes"
        description="Concursos sociales para alumnos, formación de nivel competición para participar en eventos exteriores y nacionales, y preparación de exámenes oficiales de galopes."
        path="/concursos"
        image="https://madridcampogrande.es/og/default.jpg"
      />

      <BreadcrumbLd
        items={[
          { name: "Inicio", path: "/" },
          { name: "Concursos", path: "/concursos" },
        ]}
      />

      <h1 className="text-center" style={{ marginBottom: 20 }}>
        Concursos
      </h1>

      {/* Intro (tu descripción) */}
      <p style={{ lineHeight: 1.7 }}>
        En nuestra hípica organizamos concursos sociales en nuestro centro para nuestros
        alumnos, y para los más avanzados ofrecemos clases de nivel de competición para
        así poder participar en otros eventos exteriores y competiciones nacionales. También
        disponemos de preparación y exámenes oficiales de galopes, adaptados al nivel de cada jinete.
      </p>

      {/* Imagen 1 */}
      <div style={{ margin: "25px 0" }}>
        <img
          src={"/img/portfolio/concurso-1.jpeg"}
          alt="Concurso social en pista"
          className="img-responsive img-thumbnail"
          style={{ width: "100%", height: "auto" }}
        />
      </div>

      {/* Bloque de precios */}
      <section aria-labelledby="precios" style={{ marginTop: 25 }}>
        <h3 id="precios">Precio preparación de competición</h3>
        {preciosError && (
          <div className="alert alert-warning">
            No se han podido cargar los precios en este momento.
          </div>
        )}
        {!precios && !preciosError && <p>Cargando precios...</p>}
        {preparacionCompeticion && (
          <>
            <p style={{ marginBottom: 8 }}>
              <strong>{euros(preparacionCompeticion.precioMensual)}</strong> al mes.
            </p>
            <p style={{ marginBottom: 0 }}>
              Incluye <strong>{preparacionCompeticion.clasesIncluidas} clases</strong>.
            </p>
          </>
        )}
      </section>

      {/* Imagen 2 */}
      <div style={{ margin: "25px 0" }}>
        <img
          src={"/img/portfolio/concurso-2.jpeg"}
          alt="Entrenamiento previo a concurso"
          className="img-responsive img-thumbnail"
        />
      </div>

      {/* Qué trabajamos */}
      <section aria-labelledby="que-trabajamos" style={{ marginTop: 10 }}>
        <h3 id="que-trabajamos">Qué trabajamos</h3>
        <ul>
          <li>Planificación de objetivos y calendario de competición.</li>
          <li>Trabajo técnico (doma/salto) y presentación en pista.</li>
          <li>Simulacros de recorrido y gestión de nervios.</li>
          <li>Preparación y exámenes oficiales de galopes por niveles.</li>
        </ul>
      </section>

      {/* Imagen 3 */}
      <div style={{ margin: "25px 0" }}>
        <img
          src={"/img/portfolio/concurso-3.jpeg"}
          alt="Binomio en competición"
          className="img-responsive img-thumbnail"
        />
      </div>

      {/* Información adicional */}
      <section aria-labelledby="info" style={{ marginTop: 10 }}>
        <h3 id="info">Información adicional</h3>
        <ul>
          <li>Grupos reducidos y atención personalizada.</li>
          <li>Adaptación al nivel de cada jinete y caballo.</li>
          <li>Asesoramiento para participación en concursos externos y nacionales.</li>
        </ul>
      </section>

      {/* Imagen 4 */}
      <div style={{ margin: "25px 0" }}>
        <img
          src={"/img/portfolio/concurso-4.png"}
          alt="Entrega de premios"
          className="img-responsive img-thumbnail"
        />
      </div>

      {/* Llamada a la acción */}
      <div style={{ marginTop: 25 }}>
        <Link to="/contacto" className="btn btn-primary">
          Solicitar información o plaza
        </Link>
      </div>
    </div>
  );
}
